import { Grid } from "@material-ui/core";
import React, { useContext } from "react";
import { Typography } from "@mui/material";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import { ReactComponent as DeleteVisitIcon } from "../../../src/assets/DeleteVisit.svg";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Toast from "../../components/ToastContainer/CustomToast";
import { deleteWatchlistTemplate } from "../../slices/WatchlistGlobal/WatchlistGlobalSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import { ReactComponent as DeleteIcon } from "../../assets/DeleteIcon.svg";

export default function DeleteWatchlist(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const [payload, setPayload] = React.useState({
    watchListId: props.DeleteId,
    contactEmail: props?.watchlistContactEmail,
  });

  const handleSubmit = () => {
    dispatch(deleteWatchlistTemplate(payload))
      .unwrap()
      .then((data) => {
        handleClose(false);
        if (data.code === "CVAI2003") {
          Toast(t("WATCHLISTDELETEMSG"), "success");
          handleClose();
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => {});
  };

  return (
    <>
      <DialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("COMMON004")}
          </span>
        }
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={"center"}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid>
            <DeleteIcon width="60px" height={"50px"} />
          </Grid>
          <Grid>
            <Grid
              style={{
                wordWrap: "break-word",
                opacity: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                fontSize: "17px",
                marginTop: "15px",
              }}
            >
              <Typography
                style={{
                  color: darkMode ? "#fff" : "#242424",
                  marginRight: "4px",
                }}
              >
                {t("COMMON018")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
